<script lang="ts">
  import {
    addToSum,
    currentPage,
    selectedLanguageCode,
    sum,
    Views,
  } from "./store";
  import { onMount } from "svelte";
  import { LocalizationTexts, localizedTexts } from "./texts";
  import { useResolve, link } from "svelte-navigator";
  import { get } from "svelte/store";

  let texts: LocalizationTexts = localizedTexts.de;

  let items = [
    {
      name: "Mountain Champ",
      brand: "Tranker",
      size: "35L",
      quantity: 1,
      price: 9.95,
      thumbnailUrl: "assets/backpack1.jpg",
    },
    {
      name: "Ice Climber",
      brand: "Nordwand",
      size: "30L",
      quantity: 0,
      price: 29.99,
      thumbnailUrl: "assets/backpack2.jpg",
    },
    {
      name: "Bali Pack",
      brand: "Reinhold",
      size: "35L",
      quantity: 0,
      price: 125.05,
      thumbnailUrl: "assets/backpack3.webp",
    },
  ];

  onMount(() => {
    selectedLanguageCode.subscribe((language) => {
      texts = localizedTexts[language];
    });
  });

  if (get(sum) == 0) {
    items.forEach((item) => {
      addToSum(item.price * item.quantity);
    });
  }
</script>

<div class="lg:pt-8 lg:w-152 w-auto">
  <h3 class="text-2xl font-extrabold text-black">{texts.shoppingBag}</h3>
  <div class="grid grid-cols-12 pt-8 border-bottom">
    <!-- Header -->
    <span class="table-header border-bottom col-span-5">{texts.product}</span>
    <span class="table-header border-bottom col-span-2 lg:inline hidden"
      >{texts.size}</span
    >
    <span class="table-header border-bottom lg:col-span-2 col-span-4"
      >{texts.quantity}</span
    >
    <span
      class="table-header border-bottom col-span-2 text-center"
      >{texts.price}</span
    >
    <span class="table-header border-bottom col-span-1" />
    <!-- Rows -->
    {#each items as item}
      <span
        class="table-item font-semibold flex flex-row flex-nowrap col-span-5"
      >
        <img src={item.thumbnailUrl} class="w-16" alt="Backpack thumbnail" />
        <span class="flex flex-col pl-2">
          {item.name}
          <span class="text-gray-400 text-xs">{item.brand}</span>
        </span>
      </span>
      <span class="py-1 items-center col-span-2 lg:flex hidden justify-center"
        >{item.size}</span
      >
      <span class="table-item justify-center lg:col-span-2 col-span-4">
        <button
          class={"quantity-btn" + (item.quantity <= 0 ? " disabled-btn" : " ")}
          on:click={() => item.quantity--}
          on:click={() => addToSum(-item.price)}
          disabled={item.quantity <= 0}>-</button
        >
        {item.quantity}
        <button
          class="quantity-btn"
          on:click={() => item.quantity++}
          on:click={() => addToSum(item.price)}>+</button
        >
      </span>
      <span class="table-item col-span-2 justify-center"
        >{(Math.round(item.price * item.quantity * 100) / 100).toFixed(
          2
        )}€</span
      >
      <button
        class="table-item text-gray-500 flex justify-end col-span-1"
        on:click={() => (items = items.filter((_item) => _item != item))}
        >╳</button
      >
    {/each}
    <span />
  </div>

  <!-- Summary -->
  <div class="flex justify-end pt-8 pb-8">
    <div class="grid grid-cols-3 w-full lg:w-2/3">
      <span class="text-gray-400 font-bold">{texts.subTotal}:</span>
      <span />
      <span class="font-bold text-right">{$sum.toFixed(2)}€</span>
      <span class="text-gray-400 font-bold border-bottom pb-4"
        >{texts.shipping}:</span
      >
      <span class="border-bottom pb-4" />
      <span class="font-bold pb-4 border-bottom text-right">{texts.free}</span>
      <span class="font-black text-xl pt-4 flex items-center"
        >{texts.total}:</span
      >
      <span />
      <span class="font-black text-3xl pt-4 text-right">{$sum.toFixed(2)}€</span
      >
      <a
        href="checkout"
        use:link
        class="bg-gray-700 text-white font-bold rounded-lg p-4 flex justify-center gap-2 col-span-3 lg:col-start-3 lg:col-span-1 mt-6"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
          />
        </svg>
        {texts.checkout}</a
      >
    </div>
  </div>
</div>

<style>
  .table-header {
    @apply font-bold py-3 text-gray-500;
  }
  .table-item {
    @apply flex py-1 items-center;
  }
  .quantity-btn {
    @apply bg-gray-50 w-6 h-6 rounded-lg font-bold;
  }
  .disabled-btn {
    @apply text-gray-300;
  }
  .border-bottom {
    @apply border-b border-gray-200;
  }
</style>
